<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img bg-style border-light"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
        ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
        width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <p class="control__content control__desc">{{ subtitle(4110) }}</p>
    <input class="control__input border-input font-15"
           type="text"
           [(ngModel)]="control.elementVal.getValue()?.params.groupCode" >
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
            data-testid="sendButton"
            (click)="control.addControllerGroup(control.elementVal.getValue()?.params.groupCode)">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>
    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
